// extracted by mini-css-extract-plugin
module.exports = {"page_panel":"page_panel--NewSession-Sessions-routes__2LepQ","pagePanel":"page_panel--NewSession-Sessions-routes__2LepQ","container":"container--NewSession-Sessions-routes__2AMqJ"};